import {SET_USER_LOADER, SET_USER_DATA} from "../actionTypes/users"

const initialState = {
  data: {
    main: []
  },
  meta: {
    isLoading: false
  }
}

export default (state = initialState, action) => {
  const {type, payload} = action
  switch (type) {
    case SET_USER_DATA:
      return {
        ...state,
        data: {
          ...state.data,
          main: payload
        }
      }
    case SET_USER_LOADER:
      return {
        ...state,
        meta: {
          ...state.meta,
          isLoading: payload
        }
      }
    default:
      return state
  }
}
